/**
 * The type of redux action which stores a specific JSON Web Token (JWT) into
 * the redux store.
 *
 * {
 *     type: SET_USERDATA,
 *     jwt: string
 * }
 */
export const SET_DISTRESSBTN_ENABLED = 'SET_DISTRESSBTN_ENABLED';
export const SET_DISTRESSBTN_DIMMING_VALUE = 'SET_DISTRESSBTN_DIMMING_VALUE';
export const SET_DISTRESSBTN_VOLUME_VALUE = 'SET_DISTRESSBTN_VOLUME_VALUE';
export const SET_DISTRESSBTN_MESSAGE_ENABLED = 'SET_DISTRESSBTN_MESSAGE_ENABLED';
export const SET_DISTRESSBTN_MESSAGE_TEXT = 'SET_DISTRESSBTN_MESSAGE_TEXT';
